import { useOutletContext } from "react-router-dom";
import { QRCode } from 'react-qrcode-logo';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import DefaultTopImage from '../../../images/banner_themes/default_top.webp'
import Tooltip from '@mui/material/Tooltip';
import { uploadFileURL, getImage } from "../../../utils/filesystem";
import { isValidImg } from "../../../utils/files";
import EasyCrop from "../../../components/EasyCrop";
import Pagination from '@mui/material/Pagination';
import UploadIcon from '@mui/icons-material/Upload';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState, useRef, useCallback } from "react";
import EasySnackBar from "../../../components/EasySnackBar";

export default function Share() {
    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = useOutletContext();

    const QR_SIZE = 300
    const BANNER_HEIGHT = 1280
    const BANNER_WIDTH = 720
    const IMAGE_QUALITY = 1
    const THEMES = ['basic.webp', 'fancy.webp', 'colorful.webp']

    const bannerImgRef = useRef()
    const canvasRef = useRef(null)

    const [menuLink, setMenuLink] = useState('')
    const [copiedLink, setCopiedLink] = useState(false)
    const [uploadedBannerImg, setUploadedBannerImg] = useState(null)
    const [bannerImage, setBannerImage] = useState(null)

    const [qrImage, setQrImage] = useState(null)
    const [currentTheme, setCurrentTheme] = useState(1)

    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')

    const getBannerImg = useCallback(async () => {
        const reqImageBanner = await getImage(userAuth.uid + '/top_image_qr.webp')
        if (reqImageBanner) { setBannerImage(URL.createObjectURL(reqImageBanner)) }
    }, [userAuth])

    const generateBanner = useCallback(() => {
        const canvas = canvasRef.current;

        if (canvas) {
            const ctx = canvas.getContext('2d');

            const bannerInfo = new Image();
            bannerInfo.src = require(`../../../images/banner_themes/${THEMES[currentTheme - 1]}`);

            const bannerTop = new Image();
            bannerTop.src = bannerImage ? bannerImage : DefaultTopImage;

            const QRCode = new Image();
            QRCode.src = qrImage;

            const imagesLoaded = new Promise((resolve) => {
                let loadedCount = 0;

                const checkLoaded = () => {
                    loadedCount++;
                    if (loadedCount === 3) {
                        resolve();
                    }
                };

                bannerInfo.onload = checkLoaded;
                bannerTop.onload = checkLoaded;
                QRCode.onload = checkLoaded;
            });

            imagesLoaded.then(() => {
                canvas.width = BANNER_WIDTH;
                canvas.height = BANNER_HEIGHT;

                ctx.drawImage(bannerTop, 0, 0, BANNER_WIDTH, BANNER_HEIGHT / 2);
                ctx.drawImage(bannerInfo, 0, BANNER_HEIGHT / 2 - 200);
                ctx.drawImage(QRCode, QR_SIZE - 100, 480, QR_SIZE + 20, QR_SIZE + 20);
            });
        }

    }, [currentTheme, THEMES, bannerImage, qrImage])

    useEffect(() => {
        generateBanner()
    }, [currentTheme, qrImage, bannerImage, uploadedBannerImg])

    useEffect(() => {
        if (bannerImage) { uploadFileURL(bannerImage, userAuth.uid + '/top_image_qr.webp') }
    }, [bannerImage, userAuth])

    useEffect(() => {
        if (userData) {
            setMenuLink("https://tookeat.com/" + userData.menuid)
            getBannerImg()
        }
    }, [userData, getBannerImg])

    useEffect(() => {
        const qrCode = document.getElementById("qr_code_id");

        if (qrCode) {
            const img = new Image();
            const pngUrl = qrCode
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            img.src = pngUrl
            setQrImage(pngUrl)
        }
    }, [menuLink])

    const userImgLoad = img => {
        if (!isValidImg(img)) {
            setErrorMessage('Imagen invalida, intenta con otra')
        } else {
            setUploadedBannerImg(URL.createObjectURL(img))
        }
    }

    const downloadImage = (imageURL, imageName) => {
        let downloadLink = document.createElement("a");
        downloadLink.href = imageURL;
        downloadLink.download = imageName + ".png";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };


    const copyText = () => {
        navigator.clipboard.writeText(menuLink)
            .then(() => {
                setSuccessMessage('¡Texto copiado correctamente!');
            })
            .catch((error) => {
                setErrorMessage('Error al copiar al portapapeles:');
            });

        setCopiedLink(true)
    }

    return (
        <>
            {uploadedBannerImg ?
                <EasyCrop
                    loadedImg={uploadedBannerImg}
                    setLoadedImg={setUploadedBannerImg}
                    setImage={setBannerImage}
                    aspectRatio={BANNER_WIDTH / (BANNER_HEIGHT / 2)}
                    quality={IMAGE_QUALITY}
                /> :
                <Stack spacing={2}>
                    <Typography variant="h4">
                        Compartir menú
                    </Typography>

                    <Typography variant="h5" sx={{ m: 1 }}>
                        Codigo QR
                    </Typography>

                    {menuLink === '' ? null :
                        <div style={{ display: 'none' }}>
                            <QRCode id="qr_code_id" value={menuLink} size={QR_SIZE} />
                        </div>}
                    <img src={qrImage} width={'200px'} style={{ alignSelf: 'center' }} alt="qr code" />

                    <Button
                        variant="contained"
                        onClick={() => downloadImage(qrImage, 'QR_menu_' + (userData ? userData.menuid : ''))}
                    >
                        Descargar codigo QR
                        <DownloadIcon />
                    </Button>

                    <Divider sx={{ m: 2 }} />

                    <Typography variant="h5">
                        QR Para mesa
                    </Typography>

                    <Stack
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        spacing={2}
                        flexWrap='wrap'
                    >
                        <div style={{ width: '180px', height: 'auto' }}>
                            <canvas
                                ref={canvasRef}
                                style={{ width: '100%', height: 'auto' }}
                            />
                        </div>

                        <Stack
                            justifyContent='center'
                            alignItems='center'
                            spacing={2}
                        >
                            <Typography variant="h6">
                                Personalizar Menu QR
                            </Typography>

                            <Divider sx={{ width: '90%' }} />

                            <b>Cambiar imagen superior</b>

                            <Button
                                variant="outlined"
                                onClick={() => bannerImgRef ? bannerImgRef.current.click() : null}
                            >
                                Subir imagen
                                <UploadIcon />
                            </Button>

                            <b>Seleccionar tema inferior</b>

                            <Pagination count={THEMES.length} page={currentTheme} onChange={(event, value) => setCurrentTheme(value)} />
                        </Stack>
                    </Stack>

                    <Button
                        variant="contained"
                        onClick={() => {
                            const image = canvasRef.current
                                .toDataURL('image/png')

                            downloadImage(image, 'QR_mesa_' + userData.menuid)
                        }}
                    >
                        Descargar QR para mesa
                        <DownloadIcon />
                    </Button>

                    <Divider sx={{ m: 1 }} />

                    <Typography variant="h5" sx={{ m: 1 }}>
                        Link al menú
                    </Typography>

                    <Stack
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        spacing={3}
                    >
                        <TextField value={menuLink} fullWidth />

                        <ClickAwayListener onClickAway={() => setCopiedLink(false)}>
                            <Tooltip
                                PopperProps={{
                                    disablePortal: true,
                                }}
                                onClose={() => setCopiedLink(false)}
                                open={copiedLink}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                title="Copiado!"
                                leaveDelay={500}
                            >
                                <Button onClick={copyText.bind(this)} variant="contained">
                                    Copiar Link
                                </Button>
                            </Tooltip>
                        </ClickAwayListener>
                    </Stack>
                </Stack>}

            <label style={{ display: 'none' }}>
                <input type="file" accept='image/*'
                    onChange={e => {
                        userImgLoad(e.target.files[0])
                    }}
                    ref={bannerImgRef}
                />
            </label>

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />

            <EasySnackBar
                severity='success'
                key='2'
                message={successMessage}
                setMessage={setSuccessMessage}
            />
        </>
    );
}
